export default __webpack_public_path__ + "static/Plots0101-edc6c6f78879f3a91677cdb9c6bcad6b.jpg";